
import React, { useState, lazy, Suspense } from 'react';
import { ConfigProvider, Row, Spin } from 'antd';
import { BrowserRouter as Router, Switch, Route, Redirect } from "react-router-dom";
import Circle from '@uiw/react-color-circle';
import ptBR from 'antd/lib/locale/pt_BR';
import 'moment/locale/pt-br';
import moment from 'moment';

import 'antd/dist/reset.css';
import "./App.less";
import { StateProvider } from './state';
import { reducer } from './state/reducer';
import { isAuthenticated } from './services/auth';

// Rotas carregadas sob demanda (cada uma vira um chunk próprio). Importar direto da pasta da página, não do barrel "./pages",
// senão o bundle inicial volta a carregar o ERP inteiro — o que deixava lentas as páginas públicas (ex.: assinatura de condicional).
const Login = lazy(() => import('./pages/login'));
const Home = lazy(() => import('./pages/home'));
const HomeCatalogo = lazy(() => import('./pages/homeCatalogo'));
const RecuperarSenha = lazy(() => import('./pages/recuperarSenha'));
const RecuperarSenhaGerencial = lazy(() => import('./pages/recuperarSenhaGerencial'));
const AtivarConta = lazy(() => import('./pages/ativarConta'));
const AtivarNovoEmail = lazy(() => import('./pages/ativarNovoEmail'));
const AssinaturaCondicional = lazy(() => import('./pages/assinaturaCondicional'));
const AnaliseInadimplenciaCliente = lazy(() => import('./pages/analiseInadimplencia/analiseInadimplenciaCli'));
const NovaEmpresa = lazy(() => import('./pages/novaEmpresa'));
const AtivarUsuarioPlano = lazy(() => import('./pages/novaEmpresa/ativarUsuarioPlano'));
const RenovarPlano = lazy(() => import('./pages/renovarPlano'));
const Testes = lazy(() => import('./pages/testes'));
const LoginCatalogo = lazy(() => import('./pages/loginCatalogo'));

const CarregandoPagina = () => (
    <Row justify="center" align="middle" style={{ minHeight: '100vh' }}>
        <Spin size="large" />
    </Row>
);

const PrivateRoute = ({ component: Component, ...rest }) => (
    <Route
        {...rest}
        render={props =>
            isAuthenticated() ? (
                <Component {...props} />
            ) : (
                <Redirect to={{ pathname: "/", state: { from: props.location } }} />
            )
        }
    />
);

function App() {

    moment.locale('pt-br');

    const initialState = {
        userConfig: { size: 'small' },
        ui: { showDrawer: false, showDrawerExtra: false },
        manutencao: { dados: null },
        listaSelectPaginacao: { itens: [] },
        listaTabelaDados: { itens: [] },
        listagem: { filtro: '', ordem: '', outrosFiltros: '' },
        tributacao: { empRegimeTributario: null, empEnquadramentoFiscal: null },
        parametrosEmpresa: { markupProduto: null, par_percjuromesparcelavencida: '', par_multaparcelavencida: '', par_diastoleranciacobrancajuro: '', par_tipocalculomulta: '', par_acaoparcelavencida: '', par_diastolparcelavencida: '' }
    };

    const FormSizeDemo = () => {

        const [componentSize, setComponentSize] = useState('small');

        const [color, setColor] = useState({
            primaryColor: '#0053a6',
        });

        function onColorChange(nextColor) {
            const mergedNextColor = {
                ...color,
                ...nextColor,
            };
            setColor(mergedNextColor);
            ConfigProvider.config({
                theme: mergedNextColor,
            });

        }

        return (
            <ConfigProvider locale={ptBR} componentSize={componentSize} theme={{ token: { fontSize: 12, } }}>
                <Circle
                    colors={['#11a3b3', '#0053a6']}
                    color={color.primaryColor}
                    onChange={({ hex }) => {
                        onColorChange({
                            primaryColor: hex,
                        });
                    }}
                />
                <Router>
                    <Suspense fallback={<CarregandoPagina />}>
                    <Switch>
                        <Route exact path="/" component={Login} />
                        <PrivateRoute path="/home" component={Home} />
                        <Route exact path="/ativar-novo-usuario/" component={AtivarConta} />
                        <Route exact path="/recuperar-senha" component={RecuperarSenha} />
                        <Route exact path="/assinatura-condicional" component={AssinaturaCondicional} />
                        <Route exact path="/recuperar-senhaGerencial" component={RecuperarSenhaGerencial} />
                        <Route exact path="/ativar-novo-email" component={AtivarNovoEmail} />
                        <Route exact path="/renovarPlano" component={RenovarPlano} />
                        <PrivateRoute exact path="/AnaliseInadimplenciaCliente" component={AnaliseInadimplenciaCliente} />
                        <Route exact path="/nova-empresa" component={NovaEmpresa} />
                        <Route exact path="/ativar-nova-empresa/" component={AtivarUsuarioPlano} />
                        <Route exact path="/teste" component={Testes} />
                        <Route exact path="/login-cliente" component={LoginCatalogo} />
                        <PrivateRoute path="/catalogo" component={HomeCatalogo} />
                    </Switch>
                    </Suspense>
                </Router>
            </ConfigProvider>
        )

    }

    return (
        <StateProvider initialState={initialState} reducer={reducer}>
            <FormSizeDemo />
        </StateProvider>
    );

}

export default App;